import { render, staticRenderFns } from "./formProductSales.vue?vue&type=template&id=5344a67a"
import script from "./formProductSales.vue?vue&type=script&lang=js"
export * from "./formProductSales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports